import { render, staticRenderFns } from "./subscribers.vue?vue&type=template&id=4d5d6a60&scoped=true"
import script from "./subscribers.vue?vue&type=script&lang=js"
export * from "./subscribers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d6a60",
  null
  
)

export default component.exports